import script from "./NoiCard.vue?vue&type=script&setup=true&lang=js"
export * from "./NoiCard.vue?vue&type=script&setup=true&lang=js"

import "./NoiCard.vue?vue&type=style&index=0&id=4868cd1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4868cd1e"]])

export default __exports__